import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Paper from "@material-ui/core/Paper"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import { Grid } from ".."

const useStyles = makeStyles(theme => ({
  paper: {
    borderWidth: props => (props.fullScreen ? 0 : theme.spacing(0.5)),
    borderColor: theme.palette["green"].support,
    borderStyle: "solid",
    margin: props => (props.fullScreen ? 0 : theme.spacing(0, 2)),
    maxHeight: "none",
    maxWidth: "none",
    padding: props => (props.fullScreen ? theme.spacing(2) : 0),
  },
  closeButton: {
    borderRadius: 0,
    position: "absolute",
    right: 0,
    top: 0,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  grid: {
    overflow: "visible",
    width: "100%",
  },
}))

export default props => {
  const classes = useStyles(props)
  const {
    xs,
    sm,
    md,
    lg,
    xl,
    fullScreen,
    onClose,
    children,
    ...otherProps
  } = props
  const sizes = { xs, sm, md, lg, xl }

  const closeButton = (
    <IconButton onClick={onClose} className={classes.closeButton}>
      <CloseIcon />
    </IconButton>
  )
  const paper = (
    <Paper square classes={{ root: classes.paper }} {...otherProps}>
      {onClose && closeButton}
      {children}
    </Paper>
  )

  if (fullScreen) {
    return paper
  } else {
    return (
      <Grid container xs={0} centered className={classes.grid}>
        <Grid item {...sizes}>
          {paper}
        </Grid>
      </Grid>
    )
  }
}
